<div class="popup" *ngIf="showPopup">
  <div class="overlay"></div>
  <div class="popup-content">
    <h4 class="mb-3">Novos Termos e Condições</h4>
    <p>
      Os Termos e Condições de utilização do TL Billing foram atualizados a 1 de novembro de 2026.
      Para continuar a utilizar o serviço, leia e aceite a nova versão.
    </p>
    <p>
      <a routerLink="/terms-and-conditions" target="_blank">Ler os Termos e Condições</a>
    </p>
    <div class="form-check form-check-flat form-check-primary mb-3">
      <label class="form-check-label">
        <input [(ngModel)]="accepted" type="checkbox" class="form-check-input">
        <i class="input-frame"></i>
        Li e aceito os novos Termos e Condições.
      </label>
    </div>
    <button class="btn btn-primary" (click)="accept()" [disabled]="!accepted">Continuar</button>
  </div>
</div>
